import { render, staticRenderFns } from "./UploadFilesModal.vue?vue&type=template&id=054887aa&scoped=true&"
import script from "./UploadFilesModal.vue?vue&type=script&lang=js&"
export * from "./UploadFilesModal.vue?vue&type=script&lang=js&"
import style0 from "./UploadFilesModal.vue?vue&type=style&index=0&id=054887aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054887aa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle})
